import { Offcanvas, Nav, Navbar } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import {
    BarChartFill,
    PeopleFill,
    PersonBoundingBox,
} from "react-bootstrap-icons";
import { useConfig } from "../../../../Provider/Config/config";
import { useSidebar } from "../../../../Hook/useSidebar";
import { useTranslation } from "react-i18next";
import "./MenuSidebar.css";
import { useMediaQuery } from "react-responsive";

import Logo from "../../../../Assets/Images/logo_primus3.webp";

export default function Sidebar({ showOffcanvas, setShowOffcanvas }) {
    // Hook para tradução
    const { t } = useTranslation();
    const { configs } = useConfig();
    const { isOpen, toggleSidebar } = useSidebar();
    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

    // Hook para pegar a localização da página
    const location = useLocation();
    const currentPath = location.pathname;
    const isActive = (path) => {
        const current =
            currentPath.split("/")[1] === ""
                ? "/"
                : `/${currentPath.split("/")[1]}`;
        return current === path ? "active" : "";
    };

    return (
        <>
            {/* Sidebar fixa no lado esquerdo */}
            <div
                className={`sidebar ${
                    isOpen ? "expanded" : "collapsed"
                } d-none d-md-block`}
            >
                <Nav className="flex-column">
                    <Navbar.Brand
                        className={`header-menu ${
                            isOpen ? "expanded" : "collapsed"
                        }`}
                    >
                        <div className="logo-menu">
                            <img src={Logo} alt="logo-primus" />
                        </div>
                        {isOpen && <span>Primus</span>}
                    </Navbar.Brand>
                    <Nav.Link
                        as={Link}
                        to="/dashboard"
                        className={`d-flex ${isActive("/dashboard")}`}
                    >
                        <div className={`${isOpen && "me-2"}`}>
                            <BarChartFill />
                        </div>
                        {isOpen && <span>{t("menu.dashboard")}</span>}
                    </Nav.Link>
                    <Nav.Link
                        as={Link}
                        to="/client"
                        className={`d-flex align-items-center ${isActive(
                            "/client"
                        )}`}
                    >
                        <div className={`${isOpen && "me-2"}`}>
                            <PeopleFill />
                        </div>
                        {isOpen && <span>{t("menu.client")}</span>}
                    </Nav.Link>
                    <Nav.Link
                        as={Link}
                        to="/users"
                        className={`d-flex align-items-center ${isActive(
                            "/users"
                        )}`}
                    >
                        <div className={`${isOpen && "me-2"}`}>
                            <PersonBoundingBox />
                        </div>
                        {isOpen && <span>{t("menu.users")}</span>}
                    </Nav.Link>
                </Nav>
            </div>

            {/* Sidebar Offcanvas para telas menores */}
            <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-false`}
                aria-labelledby={`offcanvasNavbarLabel-expand`}
                placement="start"
                show={isOpen && isMobile}
                onHide={toggleSidebar}
                bg={configs.theme === "dark" ? "dark" : "light"}
                data-bs-theme={configs.theme === "dark" ? "dark" : "light"}
                className="sidebar-offcanvas"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title
                        id={`offcanvasNavbarLabel-expand`}
                        className="d-flex align-items-center"
                    >
                        <div className="logo-menu me-3">
                            <img src={Logo} alt="logo-primus" />
                        </div>
                        <span>Primus</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                    <Nav className="flex-column">
                        <Nav.Link
                            as={Link}
                            to="/dashboard"
                            onClick={toggleSidebar}
                            className={`d-flex align-items-center ${isActive(
                                "/dashboard"
                            )}`}
                        >
                            <div className="m-2">
                                <BarChartFill />
                            </div>
                            <span>{t("menu.dashboard")}</span>
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/client"
                            onClick={toggleSidebar}
                            className={`d-flex align-items-center ${isActive(
                                "/client"
                            )}`}
                        >
                            <div className="m-2">
                                <PeopleFill />
                            </div>
                            <span>{t("menu.client")}</span>
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/users"
                            onClick={toggleSidebar}
                            className={`d-flex align-items-center ${isActive(
                                "/users"
                            )}`}
                        >
                            <div className="m-2">
                                <PersonBoundingBox />
                            </div>
                            <span>{t("menu.users")}</span>
                        </Nav.Link>
                    </Nav>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
        </>
    );
}
